import React from "react";

const InternationalDealers = ({className, links = []}) => {

  return ( links.length > 0 &&
    <div className={`ft_dealer-locator__international ${className || ""}`}>
      {links.map((link) =>
        <a href={link.link_url} target={link.link_target || "_self"} className="ft_dealer-locator__international-link button">
            {link.link_text}
        </a>
      )}
    </div>
  );

}

export default InternationalDealers;
